export const SEVERITY = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}
